import { render, staticRenderFns } from "./qualificationList.vue?vue&type=template&id=39c64352&scoped=true&"
import script from "./qualificationList.vue?vue&type=script&lang=js&"
export * from "./qualificationList.vue?vue&type=script&lang=js&"
import style0 from "./qualificationList.vue?vue&type=style&index=0&id=39c64352&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c64352",
  null
  
)

export default component.exports